/**
 * @repo/shared/hooks - Hooks 统一导出
 */

export { useCloseOnScroll } from "./useCloseOnScroll"
export { MOBILE_MEDIA_QUERY, useHydrated, useIsMobile, useMediaQuery } from "./useMediaQuery"
